import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex h-full w-full flex-col items-start justify-center px-6 max-md:min-h-[90vh]',
    title: 'heading-3xl max-sm:heading-2xl font-[450]',
    description: 'heading-m mt-3',
    button: 'mt-10 w-[296px]'
  }
});
